import './App.css'
import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './pages/Home/home';
import Demo from './pages/Demonstration/demo';
import Comparison from './pages/Comparison/Comparison.jsx';
import C_vector from './pages/Comparison/vector.jsx';

const App = () => {
  return (
      <Router>
        <div>
          <Routes >
              <Route path="/" element={<Home/>} />
              <Route path="demo" element={<Demo/>}/>
              <Route path="/comparison" element={<Comparison/>}/>
              <Route path="/vector" element={<C_vector/>}/>

          </Routes>
        </div>
      </Router>
  );
};

export default App;
